import { getPosition } from "../../ReusableFunctions/playbackPosition";

/*
 * getPosition returns the raw localStorage string ("629.39") — legacy callers
 * and its unit test depend on that. Redesign surfaces need seconds: fmt()
 * renders non-numbers as 0:00 and `typeof startAt === "number"` rejects
 * strings. Always a finite, non-negative number; 0 when nothing is saved.
 */
export function getPositionSeconds(mediaUrl) {
  if (!mediaUrl) return 0;
  const n = Number(getPosition(mediaUrl));
  return Number.isFinite(n) && n > 0 ? n : 0;
}
